import React from 'react'

const StepList = props => {
  return (
    <div className="StepList">
      {
        props.contentData &&
        props.contentData.steps.map((el, i) => {
          return <div className={`step ${props.stepIndex === i ? 'selected' : ''}`}
                      key={`step-${i}`}
                      onClick={() => props.controller.unsafeSetStepIndex(i)}><span
            className={`green`}>{(props.moduleIndex >= 10 ? props.moduleIndex : '0' + props.moduleIndex) + '' + (i >= 10 ? i : '0' + i)}</span>{` ${el.type || ''}`}
            <div className={`nav-button up-icon`}></div>
            <div className={`nav-button down-icon`}></div>
            <div className={`nav-button new-icon`}></div>
            <div className={`nav-button delete-icon`}></div>
          </div>
        })
      }
    </div>
  )
}

export default StepList